import React, { useState, useEffect } from "react";

type ThemeMode = "system" | "light" | "dark";

const CYCLE: ThemeMode[] = ["system", "light", "dark"];

function getStoredTheme(): ThemeMode {
  const stored = localStorage.getItem("theme");
  if (stored === "light" || stored === "dark") return stored;
  return "system";
}

function applyTheme(mode: ThemeMode) {
  const isDark =
    mode === "dark" ||
    (mode === "system" && matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.classList.toggle("dark", isDark);
}

export function ThemeToggle() {
  const [mode, setMode] = useState<ThemeMode>(getStoredTheme);

  useEffect(() => {
    applyTheme(mode);
    if (mode === "system") {
      localStorage.removeItem("theme");
    } else {
      localStorage.setItem("theme", mode);
    }
  }, [mode]);

  useEffect(() => {
    if (mode !== "system") return;
    const mq = matchMedia("(prefers-color-scheme: dark)");
    const handler = () => applyTheme("system");
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [mode]);

  function cycle() {
    setMode((prev) => {
      const i = CYCLE.indexOf(prev);
      return CYCLE[(i + 1) % CYCLE.length];
    });
  }

  const icons: Record<ThemeMode, string> = {
    system: "\u{1F5A5}",
    light: "\u2600\uFE0F",
    dark: "\u{1F319}",
  };

  const labels: Record<ThemeMode, string> = {
    system: "Sistema",
    light: "Claro",
    dark: "Escuro",
  };

  return (
    <button
      onClick={cycle}
      className="flex items-center gap-1.5 px-2 py-1 rounded-md text-sm text-gray-500 hover:text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-gray-800 transition-colors"
      title={`Tema: ${labels[mode]}`}
    >
      <span>{icons[mode]}</span>
    </button>
  );
}
